import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPaymentDetailPopupAction,
  getProviderProfileDetailAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import { getNetworkMenuId } from "../../../Utils/types";
import { ApproveRejectButton, initialFilterState } from "./helper";

export const PaymentDetailsPopup = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");
  const getViewDetailPage = useSelector(
    (state) =>
      state?.providerPortalDetailReducer?.getViewDetailPage?.paymentDetails
  );

  useEffect(() => {
    dispatch(
      getPaymentDetailPopupAction(rowData?.requestID, rowData?.sessionID)
    );
  }, []);

  const gstCertificate = getViewDetailPage?.images?.filter(
    (ele) => ele.docType === "GST"
  )?.[0];

  const cancelCheque = getViewDetailPage?.images?.filter(
    (ele) => ele.docType === "CANCELCHEQUE"
  )?.[0];

  return (
    <>
      <div className="___parent_container d-flex justify-content-between border-bottom modalHeader">
        <div className="d-flex align-items-center gap-10">
          <div className="logo-circle">
            <img src={rowData?.providerLogo} alt="" />
          </div>
          <div className="brand-name">
            <h5 className="mb-0 text-highlight font-bold">
              {rowData?.providerName}
            </h5>
          </div>
        </div>
        <div className="align-items-center gap-3 d-flex">
          {getViewDetailPage?.source &&  <h5 className="mb-0 text-highlight font-bold">
            <span style={{color:"black"}}>Action : </span>{getViewDetailPage?.source}
          </h5>}
          <button
          type="button"
          className="btn-close normal-close"
          onClick={async () => {
            await setRemark("");
            await setRowData(null);
            if (getViewDetailPage === undefined) {
              await dispatch(
                getProviderProfileDetailAction(initialFilterState)
              );
            }
          }}
        ></button>
        </div>
      </div>
      <div className="___parent_container modal-body">
        <h4
          className="font-bold text-highlight mb-4"
          style={{ letterSpacing: "1px" }}
        >
          Payment Details
        </h4>
        <div className="card-container d-flex justify-content-between gap-30 __payment_details_popup">
          <div className="cards __mp_15lr">
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">Account Number</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.accountNumber}
              </div>
            </div>
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">Aadhar Number</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.aadharNumber}
              </div>
            </div>
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">PAN Card</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.panNumber}
              </div>
            </div>
            <div className="bottom-spacing-30 d-flex justify-content-between">
              <div className="font-bold">GST Registration Number</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.gstRegistrationNumber}
              </div>
            </div>
            <h5 className="font-bold text-black bottom-spacing-20 mt-4">
              Bank Details
            </h5>
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">Bank Name</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.bankName}
              </div>
            </div>
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">Branch Name</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.branchName}
              </div>
            </div>
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">IFSC Code</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.ifscCode}
              </div>
            </div>
            <h5 className="font-bold text-black bottom-spacing-20 mt-4">
              Billing Details
            </h5>
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">Name</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.billingName}
              </div>
            </div>
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">Number</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.billingNumber}
              </div>
            </div>
            <div className="bottom-spacing-10 d-flex justify-content-between">
              <div className="font-bold">Payee Name</div>
              <div className="font-medium text-highlight">
                {getViewDetailPage?.payeeName}
              </div>
            </div>
          </div>
          <div className="cards kyc-container __mp_15lr d-flex flex-direction-column justify-content-between __mt-30">
            <div className="kyc-details pos-rel">
              <h5 className="font-bold text-black bottom-spacing-20">
                KYC Details
              </h5>
              <div className="d-flex justify-content-between bottom-spacing-10">
                <div className="font-bold">Uploaded GST Certificate</div>
                <div className="font-medium text-highlight">
                  {gstCertificate !== undefined ? (
                    <a
                      href={gstCertificate?.imageUrl}
                      target="blank"
                      className="text-decoration"
                    >
                      GST-Certificate
                    </a>
                  ) : (
                    <p className="text-unhighlighted">Not Uploaded</p>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between bottom-spacing-10">
                <div className="font-bold">Cancelled Cheque</div>
                <div className="font-medium text-highlight">
                  {cancelCheque !== undefined ? (
                    <a
                      href={cancelCheque?.imageUrl}
                      target="blank"
                      className="text-decoration"
                    >
                      Cancel Cheque
                    </a>
                  ) : (
                    <p className="text-unhighlighted">Not Uploaded</p>
                  )}
                </div>
              </div>
            </div>
            <div className="spacing-hr"></div>
            <div className="remarks mb-5">
              <h5 className="font-bold text-black bottom-spacing-20">
                Remarks
              </h5>
              <textarea
                className="textarea font-medium"
                placeholder="Type Something Here..."
                value={
                  rowData?.requestStatus !== "Pending for Approval"
                    ? rowData?.remarks
                    : remark
                }
                onChange={(e) => setRemark(e.target.value)}
                disabled={
                  rowData?.requestStatus !== "Pending for Approval" ||
                  !getNetworkMenuId()?.canEdit
                }
              ></textarea>
            </div>
            <div className="accept-reject-btns bottom-0 gap-10">
              {rowData?.requestStatus === "Pending for Approval" &&
                getNetworkMenuId()?.canEdit && (
                  <ApproveRejectButton
                    rowData={rowData}
                    setRowData={setRowData}
                    remark={remark}
                    setRemark={setRemark}
                    searchFilter={searchFilter}
                    apiParams={apiParams}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
